<template>
    <div v-if="cartCount()" class="text-center pt-2">
        <CartSummary></CartSummary>
        <div class="row align-items-center justify-content-bewteen" v-if="showButtons">
            <div class="col-md-4 col-3">
                <router-link :to="{ name: 'billing' }"
                    class="action-button action-button-big-desktop d-flex justify-content-start">
                    <a class="main-btn d-none d-md-block">{{ capitalize($t('back')) }}</a>
                    <a class="main-btn back d-block d-md-none">
                        <div class="icon arrow-icon back-icon"></div>
                    </a>
                </router-link>
            </div>
            <div class="col col-md-4 ml-md-auto">
                <button type="submit" class="btn btn-purple next-step w-100" @click="placeOrder">
                    <b>{{ $t('btn_finish') }}</b>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import CartSummary from './CartSummary.vue'
    import {
        mapGetters
    } from 'vuex'

    export default {
        name: 'PaymentMethodButtons',
        components: {
            CartSummary,
        },
        props: {
            orderDetails: {},
            validTerms: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showButtons: true
            }
        },
        watch: {
            validTerms: function(newVal) {
                if (newVal) {
                    this.showButtons = true;
                }
            }
        },
        methods: {

            ...mapGetters('cart', [
                'cartCount',
            ]),

            validate() {
                this.$router.push({
                    name: "payment-method"
                })
            },

            placeOrder() {
                this.showButtons = false;

                this.$nextTick(() => {
                    this.$emit('placeOrder')
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .back {
        width: auto;
        padding: 13px 22px !important;

        .back-icon {
            transform: rotateZ(90deg)
        }
    }

    .disabled {
        background-color: #9EABED;
        border-radius: 4px;

        &:hover {
            cursor: not-allowed;
        }
    }

    .scale-btn {
        padding: 10px;
        width: 100%;
    }

    .next-step {
        min-width: 245px;
    }

    @media only screen and (max-width: 600px) {
        .scale-btn {
            padding: 17px;
        }
    }
</style>
